<template>
    <v-flex xs12>
        <div v-if="items.length == 0" class="pa-3" style="">
            <p>Sin imágenes</p>
        </div>
        <vue-picture-swipe v-else :items="items" :options="photoSwipeOptions"></vue-picture-swipe>
    </v-flex>
</template>

<script>
    import VuePictureSwipe from 'vue-picture-swipe';

    export default{
        props:['images'],
        components: {
            VuePictureSwipe
        },
        data(){
            return {
                photoSwipeOptions: {
                    shareEl: false,
                    mainClass: 'kimsa-gallery-wrapper',
                    modal: true,
                    showHideOpacity:true,
                    hideAnimationDuration:0,
                    showAnimationDuration:0
                }
            }
        },
        computed:{
            items(){
                var vm = this
                if(!vm.images) return []

                return vm.images.map(image=>{
                    return {
                        src: image.path,
                        thumbnail: image.path,
                        title: image.name,
                        w: 600,
                        h: 400
                    }
                })

            }
        }
    }
</script>

<style scoped>

    >>>.kimsa-gallery-wrapper{
        position:fixed !important;
        height: 100vh !important;
    }

    >>>img[itemprop="thumbnail"]{
        width: 90px;
        transition: transform .1s;
    }

    >>>img[itemprop="thumbnail"]:hover{
           transform: scale(1.1)
       }
</style>